<template>
    <rkm-modal
        title="Configuração de assinatura eletrônica"
        ref="RkmModal"
    >
        <rkm-form>
            <rkm-row>
                <rkm-col cols="12">

                    <rkm-form-checkbox
                        v-if="data.form.assinaturas.length > 1"
                        :indeterminate="indeterminate"
                        @change="selectAll"
                        v-model="selectedAll"
                    >
                        Todos
                    </rkm-form-checkbox>

                    <rkm-form-checkbox-group
                        :options="data.form.assinaturas"
                        class="mb-0"
                        name="Assinaturas"
                        stacked
                        text-field="descricao"
                        v-model="model.assinaturas"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Cancelar
            </rkm-button>

            <rkm-button
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {object} from '@/mixins'

export default {
    data: () => ({
        item: null,
        selectedAll: false,
        indeterminate: true,
        model: {
            assinaturas: null,
        },
    }),
    methods: {
        open(item) {
            this.resetForm()

            this.item = item

            this.model.assinaturas = this.clone(item.assinaturas)

            this.selectedAll = this.model.assinaturas.length > 0 && this.model.assinaturas.length == this.data.form.assinaturas.length
            this.indeterminate = this.model.assinaturas.length > 0 && this.model.assinaturas.length != this.data.form.assinaturas.length

            this.$refs.RkmModal.show()
        },
        save() {
            this.item.assinaturas = this.model.assinaturas

            this.$refs.RkmModal.hide()
        },
        clean() {
            this.resetForm()
        },
        resetForm() {
            this.model.assinaturas = []
        },
        selectAll(selected) {

            this.model.assinaturas = selected ? this.data.form.assinaturas.map(c => c.id) : []
        },
    },
    mixins: [object],
    props: {
        data: {type: Object, required: true},
    },
    watch: {
        'model.assinaturas'(newValue) {

            this.selectedAll = newValue.length > 0 && newValue.length == this.data.form.assinaturas.length
            this.indeterminate = newValue.length > 0 && newValue.length != this.data.form.assinaturas.length
        },
    }
}
</script>